import styled from 'styled-components';

const Header = styled.div`
   margin: ${({ margin = '2em auto 1em auto' }: { margin?: string }) => margin};
   text-align: center;

   @media only screen and (max-width: 680px) {
      margin: 1.5em auto;
   }

   @media only screen and (max-width: 400px) {
      margin: 0.5em auto 0.7em auto;
   }
`;

export default Header;
